import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import dayjs from 'dayjs'
import { paginationInit, formatMessageNew, downLoadFileBlob, formatStartTime, formatEndTime } from '@/utils/common'
import {
  getAllDropDownList,
  getOverdueConfiguration,
  getRsoOverviewReportList,
  downloadPdf,
  exportRsoReport
} from '../../../services/rfid/defectiveReturn/defectiveReturn'
import { Button, Card } from 'antd'
import { PrinterOutlined } from '@ant-design/icons'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import ActionBar from '@/components/table/ActionBar'
import { modalError } from '../../../utils/modalUtils'

const searchItemSpan = { xl: 8, xxl: 8 }
const formItemLayout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 }
}
const dateFormat = 'YYYY-MM-DD'
const startMonth = dayjs().subtract(6, 'day')
const endMonth = dayjs()
const searchListInit = [
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.rso',
    key: 'rso',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'select',
    label: 'languageObj.defectiveReturnLocale.account',
    key: 'account',
    selectAllClear: true,
    selectList: [],
    spans: searchItemSpan
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.rsoSoldTo',
    key: 'soldTo',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'timeRange',
    label: 'languageObj.defectiveReturnLocale.nikeSubmissionDate',
    key: 'submitDate',
    format: dateFormat,
    disabledDate: current => {
      let falg = current && current > moment().endOf('day')
      return falg
    },
    initialValues: [startMonth, endMonth],
    spans: {
      xl: 8,
      xxl: 8
    }
  }
]
const renderColumn = text => {
  return <div className="word_break_all">{text}</div>
}

const RSOOverviewReport = () => {
  const mounting = useRef(false)
  const formRef = useRef(null)
  const languageState = useSelector(state => state.commonStore.language)
  const [latestOverdueConfiguration, setLatestOverdueConfiguration] = useState('')
  const [searchList, setSearchList] = useState(searchListInit)
  const [tableList, setTableList] = useState([])
  const [pagination, setPagination] = useState(paginationInit)
  const [queryFlag, setQueryFlag] = useState(false)
  const [pdfDownloadKey, setPdfDownloadKey] = useState('')

  const tableColumns = [
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.rso'),
      dataIndex: 'rso',
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.account'),
      dataIndex: 'account',
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.rsoSoldTo'),
      dataIndex: 'soldTo',
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.nikeSubmissionDate'),
      dataIndex: 'toDate',
      render: text => renderColumn(dayjs(text).format('YYYY-MM-DD'))
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.submitQty'),
      dataIndex: 'submitQty',
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.actualScanQty'),
      dataIndex: 'actualScanQty',
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.overdueQty'),
      dataIndex: 'overdueQty',
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.printBarcode'),
      dataIndex: 'printBarcode',
      render: (text, record) => {
        return (
          <Button
            type="text"
            icon={<PrinterOutlined />}
            loading={pdfDownloadKey === record.rso}
            style={{ color: '#1677ff' }}
            onClick={() => downloadPdfFun(record)}
          />
        )
      }
    }
  ]

  useEffect(() => {
    getOverdueConfigurationFun()
    getAccountList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (mounting.current) searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const getOverdueConfigurationFun = () => {
    getOverdueConfiguration().then(res => {
      const resultData = res.resultData
      setLatestOverdueConfiguration(resultData)
    })
  }

  const getAccountList = () => {
    const params = {
      type: 1
    }
    getAllDropDownList(params).then(res => {
      const resultData = res.resultData || []
      const options = resultData.map(item => ({ label: item, value: item }))
      const list = searchList.map(item => {
        if (item.key === 'account') item.selectList = options
        return item
      })
      setSearchList(list)
    })
  }

  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const params = {
      isChinese: languageState === 'zh_CN' ? true : false,
      rso: info.rso,
      account: info.account,
      soldTo: info.soldTo,
      startToTime: formatStartTime(info.submitDate),
      endToTime: formatEndTime(info.submitDate)
    }
    return params
  }

  const searchDataFun = () => {
    setTableList([])
    const params = {
      ...getParams(),
      pageNo: pagination.currentPage,
      size: pagination.pageSize
    }
    getRsoOverviewReportList(params).then(res => {
      const dt = res.resultData
      const records = dt.records || []
      const pg = { ...pagination, total: dt.total }
      setTableList(records)
      setPagination(pg)
    })
  }

  const searchDataBtn = () => {
    mounting.current = true
    const pg = { ...pagination, currentPage: 1 }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }

  const searchClearDataBtn = () => {
    const pg = { ...pagination, currentPage: 1 }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination(params)
    setQueryFlag(!queryFlag)
  }

  const downLoadFun = () => {
    const params = { ...getParams() }
    exportRsoReport(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const downloadPdfFun = record => {
    setPdfDownloadKey(record.rso)
    const params = {
      rso: record.rso
    }
    downloadPdf(params).then(res => {
      setPdfDownloadKey('')
      downLoadFileBlob(res, '', 'application/pdf', errorCode => {
        let str = ''
        switch (errorCode) {
          case '447':
            str = 'languageObj.defectiveReturnLocale.downloadPdfError1'
            break
          case '448':
            str = 'languageObj.defectiveReturnLocale.downloadPdfError2'
            break
          default:
            break
        }
        if (str) {
          modalError({ content: formatMessageNew(str) })
          return true
        }
      })
    })
  }

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            layout={formItemLayout}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container">
          {/* {renderTableTitleBar()} */}
          <ActionBar onDownload={downLoadFun}>
            <div>
              <span>{`${formatMessageNew('languageObj.defectiveReturnLocale.latestOverdueConfiguration')} `}</span>
              <span style={{ color: latestOverdueConfiguration ? 'black' : 'red' }}>
                {latestOverdueConfiguration
                  ? `<${latestOverdueConfiguration} ${formatMessageNew('languageObj.defectiveReturnLocale.day')}`
                  : `${formatMessageNew('languageObj.defectiveReturnLocale.dateMiss')}`}
              </span>
            </div>
          </ActionBar>
          <AntdTable
            rowKey={(record, index) => record.id || index}
            dataSource={tableList}
            columns={tableColumns}
            // 独一无二的标识，不能重复
            iconTop={20}
            columnsKey="rsoOverReportCoumns"
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
    </div>
  )
}
export default RSOOverviewReport
